import axios from 'axios';
import config from './configuration';
import { store } from '../../configureStore';
import { logoutUser } from '../App/actions';

const { API_TIMEOUT } = config;

const { dispatch } = store;

const instance = axios.create({
  headers: {
    'Content-Type': 'application/json',
  },
  timeout: API_TIMEOUT * 1000,
});

instance.interceptors.request.use(axiosConfig => {
  if(axiosConfig.url && store.getState() && store.getState().app && store.getState().app.custCode) {    
        let newURL = new URL(axiosConfig.url);
        const urlParams1 = new URLSearchParams(newURL.search);
        urlParams1.set('customer_code', store.getState().app.custCode);
        axiosConfig.url = newURL.protocol+"//"+newURL.host+newURL.pathname +"?"+ urlParams1.toString();
  }
  return {
    ...axiosConfig,
    headers: { ...axiosConfig.headers },
  };
});

instance.interceptors.response.use(
  response => response,
  ({ message, response }) => {
    const { data, status } = response;
    console.log("Api Error",data,status);
    if(data && data.errors && data.errors[0] && data.errors[0].code && data.errors[0].detail && data.errors[0].code === "ER-AUTH-103" && data.errors[0].detail === "Authorization Failure"){
      dispatch(logoutUser())
    }
    // eslint-disable-next-line prefer-promise-reject-errors
    return Promise.reject({ message, data, status });
  },
);

export default instance;
